<div (click)="trackGa($event)">
    <lazy-component
        moduleUri="@yourCallModule/your-call.module#YourCallModule"
        [inputs]="{ staticType: staticBlockType, trustAsHtml: true }"
        entryComponent="YourCallStaticBlockComponent">
    </lazy-component>
</div>
@if (accumulatedMarkets?.length) {
    <racing-yourcall-specials [data]="accumulatedMarkets"></racing-yourcall-specials>
}
@if (!accumulatedMarkets?.length) {
    <no-events></no-events>
}
